import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-3 gap-16 mb-16">
          <div>
            <h3 className="text-3xl font-light mb-6 tracking-tight">Irgiz Export LLP</h3>
            <p className="text-gray-400 leading-relaxed font-light text-lg">
              Agricultural commodity export from Kazakhstan. Specializing in the supply of oilseeds to international markets.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-light mb-6 text-gray-300 uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-emerald-400 transition-colors font-light"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-emerald-400 transition-colors font-light"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('origin')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-emerald-400 transition-colors font-light"
                >
                  Origin
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('logistics')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-emerald-400 transition-colors font-light"
                >
                  Logistics
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-light mb-6 text-gray-300 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-gray-400 font-light">
              <li>Kairat Otarbayev</li>
              <li>
                <a
                  href="mailto:irgizexport@gmail.com"
                  className="hover:text-emerald-400 transition-colors"
                >
                  irgizexport@gmail.com
                </a>
              </li>
              <li>Kazakhstan</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 font-light">
            © {currentYear} Irgiz Export LLP. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
